<!-- 指定顾客、客户群-->
<template>
    <div>
        <div class="box" v-if="!showList">
            <span class="choice_name">选择&nbsp;{{ employessName }}&nbsp;需要转接的顾客</span>
            <span class="choiceCustomer_txt">需要转接的顾客</span>
            <div class="parent-cell-list">
                <!-- checkedEmployeesList.contactCount>0?checkedEmployeesList.contactCount:this.employessInfo.contactCount -->
                <van-cell class="parent-cell" title="顾客" icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/inherit/customer.png" :value="'全部' + checkedEmployeesList.contactCount + '位'" @click="getcustomer()" is-link />
            </div>
            <span class="choiceGroup_txt">需要转接的顾客群</span>
            <div class="parent-cell-list">
                <van-cell class="parent-cell" title="群顾客" icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/inherit/customerBase.png" :value="'全部' + checkedEmployeesList.groupCount + '个'" is-link />
            </div>
            <div class="parent-btn">
                <van-button class="parent-span" :disabled="checkedEmployeesList.contactCount === 0" @click="toAppointmentInherit()">分配给</van-button>
            </div>
        </div>
        <!-- 列表 -->
        <div class="child" v-if="showList">
            <div class="contents">
                选择&nbsp;{{ employessName }}&nbsp;需要转接的顾客
            </div>
            <div class="employess-list">
                <!-- <van-search v-model="searchStr" placeholder="请输入搜索关键词" @search="onLoad" @clear="selClear" /> -->
                <div class="child-list-box">
                    <van-checkbox class="child-allchecked" icon-size="18px" v-model="allChecked" @click="checkAll(allChecked)">全选
                    </van-checkbox>
                    <van-checkbox-group v-model="result" ref="checkboxGroup" @change="handleCheck">
                        <van-pull-refresh class="refresh" v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
                            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :immediate-check="false">
                                <div class="child-list-div" v-for="(item, index) in checkedEmployeesList.contactList" @click="checkedDivHandle(item)" :key="index + item.id">
                                    <div class="child-contact-list flex-row">
                                        <van-checkbox class="child-check-box" icon-size="18px" :name="item" />
                                        <div class="child-img-div flex-col">
                                            <img class="child-img" referrerpolicy="no-referrer" :src="item.avatar" alt="" />
                                        </div>
                                        <div class="child-contact-txt-div flex-col justify-between">
                                            <span class="child-contact-txt">{{ item.name }}</span>
                                        </div>
                                    </div>
                                    <div class="child-section flex-col"></div>
                                </div>
                            </van-list>
                        </van-pull-refresh>
                    </van-checkbox-group>
                </div>
                <div class="bot-div flex flex-between">
                    <div class="bot-list">
                        <img class="bot-list-img" referrerpolicy="no-referrer" v-for="(item, index) in checkContactList" :key="item.id + index" :src="item.avatar" alt="" />
                    </div>
                    <van-button round class="save_btn" @click="saveContact()">确定</van-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import { mapState } from 'vuex';

    export default {

        name: "designatedCustomer",
        data() {
            return {
                showList: false, // 是否显示顾客列表
                employessInfo: {},    //选中员工信息
                checkedEmployeesList: {
                    contactCount: 0,
                    contactList: [], //总客户 
                    groupCount: 0,
                    photolist: []
                },
                checkContactList: [], //选中客户
                employessName: "", //员工姓名
                employeeIds: [],
                searchStr: "",
                page: 1,
                total: 0,
                loading: false,
                finished: false,
                refreshing: false,
                result: [],
                allChecked: false,

            };
        },

        mounted() {
            this.employessInfo = JSON.parse(this.$route.query.checkedEmployeesInfo);
            this.employessName = this.employessInfo.name;
            this.employeeIds = this.employessInfo.employeeId;
        },
        computed: {
            // ...mapState({
            //     selectedEmp: (state) => state.inherit.selectedEmp,
            // }),
        },

        methods: {
            getcustomer(val) {
                //跳转选择客户页面
                this.showList = true;
                if (this.showList)
                    this.onLoad();
            },


            //清除
            selClear() {
                this.searchStr = ""
            },

            //保存指定
            toChoice(val) {
                //跳转选择客户页面
                this.$router.push({ name: "onJobEmployeesList", query: {} });
            },

            onLoad() {
                if (!this.showList)
                    return;

                if (this.refreshing) {
                    this.page = 1
                    this.refreshing = false;
                }
                this.loading = true
                request({
                    url: `/workEmployee/empContactList`,
                    method: "post",
                    data: { limit: "10", page: this.page + "", phone: this.searchStr, employeeId: this.employeeIds },
                })
                    .then((res) => {
                        this.checkedEmployeesList.contactList = this.page == 1 ? res.data.list : this.checkedEmployeesList.contactList.concat(res.data.list);
                        this.page += 1;
                        this.total = res.data.total;
                        // // 点击进入时全选，选人后不全选
                        // if (!this.checkContactList.length) {
                        //     this.checkContactList = this.checkedEmployeesList.contactList
                        //     this.result = this.checkContactList
                        // }

                        // 全选是否被勾选上
                        this.allCheckedHandle()

                    }).catch(() => {
                        this.finished = true
                    }).finally(() => {
                        this.loading = false;
                        if (this.checkedEmployeesList.contactList.length >= this.total) {
                            this.finished = true;
                        }
                    });
            },
            // 全选按钮checked
            allCheckedHandle() {
                this.allChecked = this.checkContactList.length === this.checkedEmployeesList.contactList.length
            },

            //全选
            checkAll(checked) {
                if (checked)
                    this.$refs.checkboxGroup.toggleAll(true);
                else
                    this.$refs.checkboxGroup.toggleAll();
            },

            //check事件
            handleCheck(val) {
                this.checkContactList = []

                if (val.length) {
                    this.checkContactList = val
                } else {
                }
                this.allCheckedHandle()
                this.updateEmplyees(val)
            },

            // 清空list数据
            onRefresh() {
                // 清空列表数据
                this.finished = false;
                this.loading = true;
                // this.$refs.checkboxGroup.toggleAll();
                // this.checkedEmployeesList.contactList = [];
                this.onLoad();

            },

            // 点击div选中
            checkedDivHandle(e) {
                // 获取过去已选择
                var val = this.checkContactList
                // 判断当前选中是否在过去已选择
                var sel = val.find(n => n.id === e.id)

                if (sel) // 如果在，去除
                    val = val.filter(n => n.id != e.id)
                else // 否则，添加
                    val.push(e)
                this.result = val
                // 模仿checkebox 选中
                this.handleCheck(val)
            },
            //确定
            saveContact() {
                this.checkedEmployeesList.contactCount = this.checkContactList.length
                if (this.checkContactList.length == 0) {
                    this.$toast({
                        message: "请选择顾客",
                        position: 'top',
                    });
                }
                else {
                    this.showList = false
                }
                this.updateTransferCustomerList(this.checkContactList);
            },
            //设置要转接的顾客
            updateTransferCustomerList(customerItem) {
                this.$store.commit('inherit/SET_TRANSFER_CUSTOMER', customerItem)
            },

            //跳转在职继承页面
            toAppointmentInherit() {
                // var res = { photolist: [], checkContactList: [] }
                // res.photolist = this.checkedEmployeesList.photolist
                // res.checkContactList = this.checkContactList
                this.$router.push({ name: "appointmentInherit", query: { checkedCustomersList: JSON.stringify(this.checkContactList) } });
            },

            updateEmplyees(customerList) {
                this.$store.commit('inherit/SET_ALL_TRANSFER_CUSTOMER', customerList)
            },
        },
    };
</script>

<style scoped>
    ::-webkit-scrollbar {
        display: none;
    }

    .text-wrapper_2 {
        height: 130px;
        background-color: rgba(245, 246, 247, 1);
        width: 750px;
    }

    .text_4 {
        width: 431px;
        height: 48px;
        display: inline-block;
        color: rgba(53, 67, 76, 1);
        font-size: 34px;
        white-space: nowrap;
        line-height: 48px;
        text-align: left;
        margin: 50px 0 0 30px;
    }

    .box {
        position: relative;
        width: 750px;
        height: 1630px;
        background-color: rgba(245, 246, 247, 1);
    }

    .parent-btn {
        margin-top: 400px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .van-pull-refresh {
        height: 80%;
    }

    .parent-span {
        background-color: #333f48;
        width: 80%;
        height: 80px;
        border-radius: 50px;
        color: rgba(255, 255, 255, 1);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 32px;
    }

    .parent-cell-list {
        width: 100%;
        margin-top: 20px;
        padding: 10px 30px 10px 30px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .parent-cell {
        height: 100px;
        /* background-color: rgba(255, 255, 255, 1); */
        width: 100%;
        border-radius: 8px;
    }

    .choice_name {
        width: 531px;
        height: 48px;
        display: inline-block;
        color: rgba(53, 67, 76, 1);
        font-size: 34px;
        white-space: nowrap;
        line-height: 48px;
        text-align: left;
        margin: 50px 0 0 30px;
    }

    .contents {
        width: 750px;
        height: 130px;
        background: #f5f6f7;
        font-size: 34px;
        font-weight: 700;
        color: #35434c;
        padding: 50px 0 32px 30px;
    }

    .choiceCustomer_txt {
        width: 182px;
        height: 37px;
        display: inline-block;
        color: rgba(160, 172, 181, 1);
        font-size: 26px;
        white-space: nowrap;
        line-height: 37px;
        text-align: left;
        margin: 50px 0 0 30px;
    }

    .choiceCustomer_box {
        height: 100px;
        border-radius: 12px;
        background-color: rgba(255, 255, 255, 1);
        width: 690px;
        margin: 30px 0 0 30px;
    }

    .choiceCustomer_group {
        width: 640px;
        height: 40px;
        margin: 30px 0 0 20px;
    }

    .choiceCustomer_image {
        width: 40px;
        height: 40px;
    }

    .choiceCustomer_span {
        width: 112px;
        height: 40px;
        display: inline-block;
        color: rgba(53, 67, 76, 1);
        font-size: 28px;
        white-space: nowrap;
        line-height: 40px;
        text-align: left;
        margin-left: 10px;
    }

    .choiceCustomer_hr {
        width: 15px;
        height: 26px;
        background: url(https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/arrow.png) 0px 0px no-repeat;
        background-size: 16px 26px;
        margin: 8px 0 0 463px;
    }

    .choiceGroup_txt {
        width: 208px;
        height: 37px;
        display: inline-block;
        color: rgba(160, 172, 181, 1);
        font-size: 26px;
        white-space: nowrap;
        line-height: 37px;
        text-align: left;
        margin: 40px 0 0 30px;
    }

    .choiceGroup_box {
        height: 100px;
        border-radius: 12px;
        background-color: rgba(255, 255, 255, 1);
        width: 690px;
        margin: 30px 0 0 30px;
    }

    .choiceGroup_group {
        width: 640px;
        height: 40px;
        margin: 30px 0 0 20px;
    }

    .choiceGroup_image {
        width: 40px;
        height: 40px;
    }

    .choiceGroup_span {
        width: 140px;
        height: 40px;
        display: inline-block;
        color: rgba(53, 67, 76, 1);
        font-size: 28px;
        white-space: nowrap;
        line-height: 40px;
        text-align: left;
        margin-left: 10px;
    }

    .choiceGroup_hr {
        width: 15px;
        height: 26px;
        background: url(https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/arrow.png) 100% no-repeat;
        margin: 7px 0 0 435px;
    }

    .btn_save {
        height: 88px;
        border-radius: 44px;
        background-color: rgba(51, 63, 72, 1);
        width: 630px;
        margin: 444px 0 0 60px;
    }

    .txt_save {
        width: 66px;
        height: 45px;
        display: inline-block;
        color: rgba(255, 255, 255, 1);
        font-size: 32px;
        letter-spacing: 1px;
        white-space: nowrap;
        line-height: 45px;
        text-align: center;
        margin: 22px 0 0 283px;
    }

    :deep(.van-cell__title) {
        margin-top: 8px;
    }

    :deep(.van-icon__image) {
        margin-top: 14px;
    }

    :deep(.van-cell__right-icon) {
        margin-top: 12px;
    }

    :deep(.van-cell__value) {
        margin-top: 12px;
    }

    .employess-list {
        background-color: #ffffff;
    }

    .child-list-box {
        height: 78vh;
        justify-content: space-between;
        margin: 0 auto 0;
        position: relative;
        z-index: 1;
        overflow-y: auto;
    }

    .child-allchecked {
        margin-top: 50px;
        margin-left: 30px;
    }

    .child-list-div {
        /* margin-top: 20px; */
        margin-left: 30px;
        padding-bottom: 1px;
    }

    .child-contact-list {
        background-color: rgb(255 255 255);
        /* height: 150px; */
    }

    .child-check-box {
        /* height: 35px; */
        margin-top: 40px;
        margin-left: 3px;
    }

    .child-img-div {
        position: relative;
        width: 70px;
        height: 70px;
        border-radius: 10px;
        overflow: hidden;
        margin-left: 30px;
        margin-top: 30px;
    }

    .child-img {
        z-index: 2;
        position: absolute;
        left: 0;
        top: 0;
        width: 70px;
        height: 70px;
    }

    .child-contact-txt-div {
        width: 90px;
        height: 60px;
        margin-left: 30px;
        margin-top: 52px;
    }

    .child-contact-txt {
        width: 90px;
        height: 42px;
        display: inline-block;
        color: rgba(53, 67, 76, 1);
        font-size: 30px;
        white-space: nowrap;
        line-height: 42px;
        text-align: left;
    }

    .child-contact-label {
        width: 32px;
        height: 32px;
        margin: 55px 0 0 384px;
    }

    .child-section {
        width: 520px;
        height: 1px;
        background-color: rgba(215, 215, 215, 1);
        margin: 2px 0 0 170px;
    }

    .bot-div {
        position: absolute;
        bottom: 0px;
        border: 1px solid rgba(203, 203, 203, 1);
        background-color: rgba(245, 246, 247, 1);
        /* margin-top: 450px; */
        width: 750px;
    }

    .bot-list {
        width: 65%;
        height: 100px;
        display: flex;
        margin: 20px 10px 10px 10px;
        /* margin-top: 10px; */
        overflow-x: auto;
    }

    .bot-list-img {
        width: 70px;
        height: 70px;
        margin-left: 20px;
        border-radius: 5px;
    }

    .save_btn {
        width: 162px;
        height: 66px;
        background: #333f48;
        border-radius: 44px;
        font-size: 32px;
        color: rgba(255, 255, 255, 1);
        margin-top: 20px;
        margin-right: 15px;
    }
</style>
